import { FilterType, MapTheme, WhereOperator, } from "@biggeo/bg-server-lib/studio";
import isEqual from "lodash/isEqual";
import { match } from "ts-pattern";
export var GeospatialSelectionType;
(function (GeospatialSelectionType) {
    GeospatialSelectionType["viewport"] = "viewport";
    GeospatialSelectionType["multipolygon"] = "multipolygon";
})(GeospatialSelectionType || (GeospatialSelectionType = {}));
export const matchOperatorsByType = {
    [FilterType.BooleanType]: [
        WhereOperator.equals,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
    [FilterType.StringType]: [
        WhereOperator.equals,
        WhereOperator.contains,
        WhereOperator.startsWith,
        WhereOperator.endsWith,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
    [FilterType.NumberType]: [
        WhereOperator.eq,
        WhereOperator.neq,
        WhereOperator.gt,
        WhereOperator.gte,
        WhereOperator.lt,
        WhereOperator.lte,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
    [FilterType.DateType]: [
        WhereOperator.eq,
        WhereOperator.neq,
        WhereOperator.gt,
        WhereOperator.gte,
        WhereOperator.lt,
        WhereOperator.lte,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
};
export const getOperatorsByType = (type) => matchOperatorsByType[type];
export const getWhereOperatorLabel = ({ operator, verbose = false, }) => match(operator)
    .with(WhereOperator.eq, () => (verbose ? "Equals" : "="))
    .with(WhereOperator.neq, () => (verbose ? "Not Equals" : "!="))
    .with(WhereOperator.gt, () => (verbose ? "Greater Than" : ">"))
    .with(WhereOperator.gte, () => verbose ? "Greater Than Or Equals" : ">=")
    .with(WhereOperator.lt, () => (verbose ? "Less Than" : "<"))
    .with(WhereOperator.lte, () => (verbose ? "Less Than Or Equals" : "<="))
    .with(WhereOperator.isEmpty, () => "Is Empty")
    .with(WhereOperator.isNotEmpty, () => "Is Not Empty")
    .with(WhereOperator.startsWith, () => "Starts With")
    .with(WhereOperator.endsWith, () => "Ends With")
    .with(WhereOperator.equals, () => "Equals")
    .otherwise(() => "Contains");
export const getFilterValueString = (type, data) => {
    return match(type)
        .with(FilterType.BooleanType, () => data.booleanData ? data.booleanData.toString() : undefined)
        .with(FilterType.DateType, () => data.dateData ? data.dateData.toString() : undefined)
        .with(FilterType.NumberType, () => data.numberData ? data.numberData.toString() : undefined)
        .with(FilterType.StringType, () => data.stringData ? data.stringData.toString() : undefined)
        .exhaustive();
};
export const getFilterData = (type, value) => {
    return {
        ...(isEqual(type, FilterType.BooleanType) && {
            booleanData: value ? value === "true" : null,
        }),
        ...(isEqual(type, FilterType.DateType) && {
            dateData: value ? new Date(value) : null,
        }),
        ...(isEqual(type, FilterType.NumberType) && {
            numberData: value ? Number.parseInt(value) : null,
        }),
        ...(isEqual(type, FilterType.StringType) && {
            stringData: value ? value : null,
        }),
    };
};
export const getMapStyleImage = (style) => match(style)
    .with(MapTheme.light, () => "https://sabiggeomedia01.blob.core.windows.net/test/4155b5e6-b287-43dd-a85b-88df630b063b.png.png")
    .with(MapTheme.dark, () => "https://sabiggeomedia01.blob.core.windows.net/test/43931eb1-cb05-c2ed-20f6-60af722042d6.png.png")
    .with(MapTheme.outdoors, () => "https://sabiggeomedia01.blob.core.windows.net/test/ce86263f-5d64-df87-c7b3-9cf73e786963.png.png")
    .with(MapTheme.streets, () => "https://sabiggeomedia01.blob.core.windows.net/test/046c21f3-e1cb-8f59-c239-a178ee572406.png.png")
    .exhaustive();
export const getMapStyleSprite = (style) => match(style)
    .with(MapTheme.light, () => "mapbox://styles/mapbox/light-v11?optimize=true")
    .with(MapTheme.dark, () => "mapbox://styles/mapbox/dark-v11?optimize=true")
    .with(MapTheme.outdoors, () => "mapbox://styles/mapbox/outdoors-v12?optimize=true")
    .with(MapTheme.streets, () => "mapbox://styles/mapbox/streets-v12?optimize=true")
    .exhaustive();
//# sourceMappingURL=map-helpers.js.map